import { FC, ReactElement } from 'react'

import cn from 'classnames'

import styles from './styles.module.scss'

export interface ISlideParams {
  id: string | number
  link: string
  author: {
    avatar?: string
    avatarAlt?: string
    name: string
    position?: string
  }
  image: any
  imageAlt?: string
  imageWidth: number
  title: string | ReactElement
  text: string | ReactElement
  isVipPage?: boolean
  isWidget?: boolean
}

export const Slide: FC<ISlideParams> = (props) => {
  return (
    <div className={cn(styles.slide, { [styles.vip]: props.isVipPage })}>
      {!props.isWidget ? (
        <img
          className={cn(styles.slide__image, styles.slide__image__mobile)}
          src={props.image}
          alt={props.imageAlt}
          width={props.imageWidth}
        />
      ) : (
        <div className={cn(styles.slide__image, styles.slide__image__mobile)}>{props.image}</div>
      )}

      <h3 className={cn(styles.slide__title, { [styles.vip]: props.isVipPage })}>{props.title}</h3>
      <p className={cn(styles.slide__text, { [styles.vip]: props.isVipPage })}>{props.text}</p>
      <div className={cn(styles.slide__bottom)}>
        <div className={styles.slide__author}>
          <img src={props.author.avatar} alt={props.author.avatarAlt} />
          <div className={cn(styles.slide__author__content, { [styles.vip]: props.isVipPage })}>
            <h4>{props.author.name}</h4>
            <p>{props.author.position}</p>
          </div>
        </div>

        {!props.isWidget ? (
          <img className={styles.slide__image} src={props.image} alt={props.imageAlt} width={props.imageWidth} />
        ) : (
          <div className={styles.slide__image}>{props.image}</div>
        )}
      </div>
    </div>
  )
}
